import httpApiApplication from 'app/http/httpApiApplication';
import { type CatalogModel } from 'app/modules/Parameters/Catalog/Catalog/models/types';

export const getSystemMessage = (code: string): Promise<CatalogModel> => {
  return httpApiApplication.get<CatalogModel>(`/catalog-values/system-message/${code}`, {
    headers: { lang: true }
  });
};
